import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {CreateSchemaContext} from "./context/CreateSchemaContext";
import {WizardStepProps} from "../../wizard/Wizard";
import SchemaRegistry from "../registry/SchemaRegistry";

class CompleteCreateSchemaStep extends React.Component<WizardStepProps> {

  static contextType = CreateSchemaContext;

  render() {
    return (
      <Container className="CompleteCreateSchemaStep no-padding" fluid>
        <Row>
          <Col>
            <SchemaRegistry fields={['id', 'label', 'creator', 'versionInfo', 'created', 'updated', 'bound']} showActions={true}/>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default CompleteCreateSchemaStep;
